import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalInfoComponent } from 'src/app/shared-modules/core-shared/components/modal-info/modal-info.component';
import { ModalSuccessComponent } from 'src/app/shared-modules/core-shared/components/modal-success/modal-success.component';
import { ModalConfirmComponent } from '../../../shared-modules/core-shared/components/modal-confirm/modal-confirm.component';
import { Dataset } from '../../models';
import { ConfirmModalOptions } from '../../models/confirm-modal-options.model';
import { SuccessModalOptions } from '../../models/success-modal-options.model';

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    constructor(
        private modalService: NgbModal,
        private translateService: TranslateService,
    ) {}

    openConfirm(confirmOptions: ConfirmModalOptions): NgbModalRef {
        const modalOptions: NgbModalOptions = { centered: true, size: 'md', ...(confirmOptions?.options || {}) };
        const modal: NgbModalRef = this.modalService.open(ModalConfirmComponent, modalOptions);
        const confirmModal = <ModalConfirmComponent>modal.componentInstance;

        confirmModal.confirmText = confirmOptions.confirmText || this.translateService.instant('GENERAL.OK');
        confirmModal.inputPlaceholder = confirmOptions.inputPlaceholder || '';
        confirmModal.message = confirmOptions.message;
        confirmModal.warningMessage = confirmOptions.warningMessage;

        confirmModal.showCancel = confirmOptions.showCancel == null ? true : confirmOptions.showCancel;
        confirmModal.cancelText = confirmOptions.cancelText || this.translateService.instant('GENERAL.CANCEL');

        confirmModal.showClose = confirmOptions.showClose == null ? true : confirmOptions.showClose;

        confirmModal.showCustom = confirmOptions.showCustom == null ? false : confirmOptions.showCustom;
        confirmModal.customText = confirmOptions.customText || '';
        confirmModal.customCssClass = confirmOptions.customCssClass;
        confirmModal.buttonsContainerCustomCssClass = confirmOptions.buttonsContainerCustomCssClass;
        confirmModal.showInput = confirmOptions.showInput == null ? false : confirmOptions.showInput;
        confirmModal.title = confirmOptions.modalTitle || 'Confirmation';
        confirmModal.isTitleCentered = confirmOptions.isTitleCentered || false;
        confirmModal.isBodyCentered = confirmOptions.isBodyCentered || false;
        confirmModal.customCssClassConfirmBtn = confirmOptions.customCssClassConfirmBtn || 'btn-primary';
        return modal;
    }

    showSuccess(successOptions?: SuccessModalOptions): NgbModalRef {
        const modalOptions: NgbModalOptions = { centered: true, size: 'md', ...(successOptions?.options || {}) };
        const modal: NgbModalRef = this.modalService.open(ModalSuccessComponent, modalOptions);
        const successModal = <ModalSuccessComponent>modal.componentInstance;
        if (successOptions) {
            if (successOptions.title) {
                successModal.title = successOptions.title;
            }
            if (successOptions.message) {
                successModal.message = successOptions.message;
            }
            if (successOptions.buttonText) {
                successModal.buttonText = successOptions.buttonText;
            }
            if (successOptions.buttonAction) {
                successModal.buttonAction = successOptions.buttonAction;
            }
        }
        return modal;
    }

    showInfo(options: { title?: string; message: string }, isAtDatasetList?: boolean, currentDataset?: Dataset): NgbModalRef {
        const modalOptions: NgbModalOptions = { centered: true, size: 'md' };
        const modal: NgbModalRef = this.modalService.open(ModalInfoComponent, modalOptions);
        const infoModal = <ModalConfirmComponent>modal.componentInstance;
        infoModal.message = options.message;
        infoModal.isAtDatasetList = isAtDatasetList;
        infoModal.currentDataset = currentDataset;
        return modal;
    }
}
